var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseWhiteHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_close_white_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.780638,11.2092094 C20.0595839,10.9302635 20.5118446,10.9302635 20.7907906,11.2092094 C21.0697365,11.4881554 21.0697365,11.9404161 20.7907906,12.219362 L20.7907906,12.219362 L17.01,16 L20.7907906,19.780638 C21.0418419,20.0316893 21.066947,20.4231256 20.866106,20.702254 L20.7907906,20.7907906 C20.5118446,21.0697365 20.0595839,21.0697365 19.780638,20.7907906 L19.780638,20.7907906 L16,17.01 L12.219362,20.7907906 C11.9683107,21.0418419 11.5768744,21.066947 11.297746,20.866106 L11.2092094,20.7907906 C10.9302635,20.5118446 10.9302635,20.0595839 11.2092094,19.780638 L11.2092094,19.780638 L14.99,16 L11.2092094,12.219362 C10.9581581,11.9683107 10.933053,11.5768744 11.133894,11.297746 L11.2092094,11.2092094 C11.4881554,10.9302635 11.9404161,10.9302635 12.219362,11.2092094 L12.219362,11.2092094 L16,14.99 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_close_white_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape-Copy",
    fill: "#5697B7",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseWhiteHover);
export default __webpack_public_path__ + "static/media/icon_close_white_hover.ec287df7a4bcbd6de3f274f1ba63764c.svg";
export { ForwardRef as ReactComponent };